/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectTaskDependencyCommand } from '../../models/delete-project-task-dependency-command';
import { DeleteProjectTaskDependencyCommandResult } from '../../models/delete-project-task-dependency-command-result';

export interface ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Params {
      body?: DeleteProjectTaskDependencyCommand
}

export function apiProjectTaskDependencyDeleteProjectTaskDependencyDelete(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDependencyDeleteProjectTaskDependencyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDependencyDeleteProjectTaskDependencyDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectTaskDependencyCommandResult>;
    })
  );
}

apiProjectTaskDependencyDeleteProjectTaskDependencyDelete.PATH = '/api/ProjectTaskDependency/DeleteProjectTaskDependency';
